export interface LoginForm {
    email: string;
    password: string;
    rememberMe?: boolean;
}

export interface SignupForm {
    name: string;
    email: string;
    password: string;
}

export interface ResetPasswordForm {
    password: string;
    confirmPassword: string;
}

export interface ForgotPasswordForm {
    email: string;
}

export interface CreateTenantForm {
    name: string;
}

export interface TenantInfo {
    id: string;
    name: string;
    createdAt: string;
    createdBy: string;
    updatedAt: string;
    updatedBy: string;
    plan: string;
    planStatus: string;
    url: string;
    status: string;
    roles: UserRole[];
}

export interface User {
    id: string;
    _id: string;
    emailVerified: boolean;
    email: string;
    fullName: string;
    tenants: any[];
    avatars: UserAvatar[];
    status: UserStatus;
    roles: UserRole[];
    firstName: string;
    lastName: string;
}

export interface UserAvatar {
    id: string;
    name: string;
    publicUrl: string;
    privateUrl: string;
}

export enum UserStatus {
    Active = 'active',
    Invited = 'invited'
}

export enum UserRole {
    Admin = 'admin',
    Custom = 'custom'
}

export enum PlanTenant {
    Free = 'free',
    Growth = 'growth',
    Enterprise = 'enterprise'
}

export interface PermissionRequired {
    id: string;
    allowedRoles: UserRole[];
    allowedPlans: PlanTenant[];
}

export interface ResponseGetMembersOfTenant {
    count: number;
    rows: User[];
}

export interface InviteMemberPost {
    emails: string[];
    roles: string[];
}

export interface UpdateProfileForm {
    firstName: string;
    lastName: string;
    avatars?: UserAvatar[];
    phoneNumbers?: string;
}

export const isUserInvited = (user: User) => user.status === UserStatus.Invited;

export const isAdminUser = (user: User) => {
    return user.roles.includes(UserRole.Admin);
};

export const getRoleNameOfUser = (role: UserRole) => {
    switch (role) {
        case UserRole.Admin:
            return 'Admin';
        case UserRole.Custom:
            return 'Custom Role';
        default:
            break;
    }
};

export const getFullNameOfUser = (user: User) => {
    return `${user.firstName ?? ''} ${user.lastName ?? ''}`;
};

export const getAvatarUrlOfUser = (user: User) => {
    if (user.avatars && user.avatars.length > 0) {
        return user.avatars[0].publicUrl;
    }
    return '';
};
